export default __webpack_public_path__ + "static/media/tuffHammerPics1.7d15f61a.jpeg";